class ClinicalResults extends HTMLElement {
	constructor() {
		super();
		this.animateGauge = this.getAttribute('animate-gauge') === 'true';
		this.animationDuration = parseInt(this.getAttribute('animation-duration')) || 1500;
		this.hasAnimated = false;
	}

	connectedCallback() {
		if (this.animateGauge) {
			this.setupObserver();
		} else {
			// If no animations, just set the final state immediately
			this.animateAllResults(0);
		}
	}

	setupObserver() {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting && !this.hasAnimated) {
						this.hasAnimated = true;
						this.animateAllResults(this.animationDuration);
					}
				});
			},
			{
				threshold: 0.2,
				rootMargin: '0px 0px -50px 0px',
			},
		);

		observer.observe(this);
	}

	animateAllResults(duration) {
		const items = this.querySelectorAll('.clinical-results__item');

		items.forEach((item, index) => {
			const delay = index * 100; // Stagger animation
			setTimeout(() => {
				this.animateResult(item, duration);
			}, delay);
		});
	}

	animateResult(item, duration) {
		const value = parseFloat(item.getAttribute('data-value')) || 0;
		const progressCircle = item.querySelector('.clinical-results__circle-progress');

		if (!progressCircle) return;

		// Calculate the stroke-dashoffset based on percentage
		// Circle circumference ≈ 339.292 (2 * π * 54)
		const circumference = 339.292;
		const percentage = Math.min(Math.max(value, 0), 100);
		const offset = circumference - (percentage / 100) * circumference;

		// Animate gauge
		if (this.animateGauge && duration > 0) {
			// Start from full offset (empty)
			progressCircle.style.transition = 'none';
			progressCircle.style.strokeDashoffset = circumference;

			// Force reflow
			progressCircle.offsetHeight;

			// Animate to target
			progressCircle.style.transition = `stroke-dashoffset ${duration}ms ease-out`;
			progressCircle.style.strokeDashoffset = offset;
		} else {
			// Set immediately
			progressCircle.style.strokeDashoffset = offset;
		}
	}
}

if (!customElements.get('clinical-results')) {
	customElements.define('clinical-results', ClinicalResults);
}
